module.exports = __webpack_public_path__ + "static/media/106_contentcreation.12070a07.png";